import { FC } from 'react';
import styled from 'styled-components';

import { DoorBuilderBreakingChange } from 'order/wizard/orderStyles/interface/DoorBuilderBreakingChange';
import { InvalidItemsAndModifications } from 'order/wizard/orderStyles/shared/InvalidItemsAndModifications';

import { ButtonPrimary, ButtonSecondary } from 'shared/components/Button';
import { H2, P } from 'shared/components/Typography';
import { Spacer } from 'shared/components/Layout';
import { anzac, nevada } from 'shared/config/Colors';
import { Wrapper } from 'shared/components/Wrapper';
import Loader from 'shared/components/Loader';

const DoorBuilderBreakingChangesContainer = styled.div`
  padding: 19px 24px;
  min-width: 433px;
  max-width: 433px;
`;

interface DoorBuilderBreakingChangesProps {
  breakingChanges: DoorBuilderBreakingChange[] | null;
  dismiss: () => void;
  confirm: () => void;
  loading: boolean;
}

const DoorBuilderBreakingChanges: FC<DoorBuilderBreakingChangesProps> = ({
  breakingChanges,
  dismiss,
  confirm,
  loading,
}) => {
  return (
    <DoorBuilderBreakingChangesContainer>
      <H2>Invalid items and modifications</H2>

      <Spacer h="25px" />

      <P color={nevada}>
        Some line items or modifiers were impacted by the change you made,
        rendering them invalid. Additional modification will be required for
        certain modifiers or line items.
      </P>

      <Spacer h="10px" />

      <P color={nevada}>Would you like to save this change?</P>

      <Spacer h="25px" />

      <Wrapper color={nevada}>
        <InvalidItemsAndModifications
          items={breakingChanges?.map((breakingChange) => ({
            id: breakingChange.lineItemId,
            number: breakingChange.lineItemNumber,
            code: breakingChange.lineItemCode,
            isValid: !breakingChange.isBreakingChange,
            modifications: breakingChange.breakingChangeModifications,
          }))}
        />
      </Wrapper>

      <Spacer h="20px" />

      <Wrapper flex justifyEnd>
        <ButtonSecondary onClick={dismiss}>Cancel</ButtonSecondary>

        <Spacer w="16px" />

        <ButtonPrimary onClick={confirm} disabled={loading} bgColor={anzac}>
          Yes, Save
          <Loader size={16} insideButton noSpacing hidden={!loading} />
        </ButtonPrimary>
      </Wrapper>
    </DoorBuilderBreakingChangesContainer>
  );
};

export default DoorBuilderBreakingChanges;
